"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LDConsistencyCheck = void 0;
/**
 * Used for reporting the state of a consistency check.
 */
var LDConsistencyCheck;
(function (LDConsistencyCheck) {
    LDConsistencyCheck[LDConsistencyCheck["Inconsistent"] = 0] = "Inconsistent";
    LDConsistencyCheck[LDConsistencyCheck["Consistent"] = 1] = "Consistent";
    LDConsistencyCheck[LDConsistencyCheck["NotChecked"] = 2] = "NotChecked";
})(LDConsistencyCheck || (exports.LDConsistencyCheck = LDConsistencyCheck = {}));
//# sourceMappingURL=LDMigrationVariation.js.map